import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LoadHierarchyModal } from "../store/HierarchyModalStore";
import * as SnackbarActions from "../store/SnackbarStore";
import { userInRoles, UserRoleTypeEnum } from "../services/authService";
import HierarchyModalForm from "./HierarchyModalForm";
import { HierarchyModalFormMode } from "./HierarchyModalForm";
import ConfirmModal from "./ConfirmModal";
import PropTypes from "prop-types";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  withStyles
} from "@material-ui/core";
import { DeleteHierarchy } from "../services/hierarchyService";
import styles from "../wrappers/admin/Admin.Styles";

class HierarchyManager extends Component {
  state = {
    selectHierarchy: 0,
    selectAction: 0,
    addHierarchyOpen: false,
    initialHierarchy: {
      id: 0,
      name: "",
      hierarchyTypeId: 1
    }
  };

  handleChange = async event => {
    const { hierarchyChange } = this.props;
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.name === "selectHierarchy") {
      hierarchyChange(event.target.value);
    }
  };

  getHierarchyById = id => {
    const { hierarchies } = this.props;
    return hierarchies.find(h => h.id === id);
  };

  handleClose = () => {
    const { hierarchyAdded } = this.props;
    this.setState({ addHierarchyOpen: false });
    if (hierarchyAdded) hierarchyAdded({});
  };

  handleDelete = async () => {
    const { hierarchyDeleted, sendError } = this.props;
    const hierarchyId = this.state.selectHierarchy;
    try {
      var result = await DeleteHierarchy(hierarchyId);
      if (result && result.success === true) {
        this.setState({ selectHierarchy: 0, showConfirmDelete: false });
        hierarchyDeleted({ hierarchyId });
      } else {
        sendError({ status: 500, title: "Unable to delete hierarchy." });
      }
    } catch (error) {
      sendError(error);
    }
  };

  handleCancelDelete = () => {
    this.setState({ showConfirmDelete: false });
  };

  handleHierarchyAction = async event => {
    const { LoadHierarchyModal, hierarchyTypeId } = this.props;
    const initialHierarchy = {
      ...this.state.initialHierarchy,
      hierarchyTypeId
    };

    switch (this.state.selectAction) {
      case "Add":
        this.setState({ addHierarchyOpen: true });
        LoadHierarchyModal(initialHierarchy, HierarchyModalFormMode.ADD);
        break;
      case "Edit":
        if (this.state.selectHierarchy > 0) {
          const hierarchy = this.getHierarchyById(this.state.selectHierarchy);
          LoadHierarchyModal(hierarchy, HierarchyModalFormMode.EDIT);
          this.setState({ addHierarchyOpen: true });
        }
        break;
      case "Delete":
        if (this.state.selectHierarchy > 0) {
          const hierarchy = this.getHierarchyById(this.state.selectHierarchy);
          this.setState({
            showConfirmDelete: true,
            deleteHierarchyName: hierarchy.name
          });
        }
        break;
      case "Duplicate":
        if (this.state.selectHierarchy > 0) {
          const hierarchy = this.getHierarchyById(this.state.selectHierarchy);
          LoadHierarchyModal(
            initialHierarchy,
            HierarchyModalFormMode.DUPLICATE,
            hierarchy
          );
          this.setState({ addHierarchyOpen: true });
        }
        break;
      default:
    }
  };

  render() {
    const { user, userIsLoading, classes, hierarchies } = this.props;

    return (
      <div className={classes.root} style={{ marginBottom: 25 }}>
        <form autoComplete="off">
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="hierarchy-select">Hierarchy</InputLabel>
            <Select
              value={this.state.selectHierarchy}
              onChange={this.handleChange}
              inputProps={{
                name: "selectHierarchy",
                id: "selectHierarchy"
              }}
              className={classes.textFieldMed}
            >
              <MenuItem value="0">
                <em>None</em>
              </MenuItem>
              {hierarchies.map(hierarchy => {
                return (
                  <MenuItem key={hierarchy.id} value={hierarchy.id}>
                    {hierarchy.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          {userInRoles(user, [UserRoleTypeEnum.Administrator]) ? (
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="hierarchy-select">Action</InputLabel>
              <Select
                value={this.state.selectAction}
                onChange={this.handleChange}
                inputProps={{
                  name: "selectAction",
                  id: "selectAction"
                }}
                className={classes.textFieldShort}
              >
                <MenuItem value="0">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Add">Add</MenuItem>
                <MenuItem value="Edit">Edit</MenuItem>
                <MenuItem value="Delete">Delete</MenuItem>
                <MenuItem value="Duplicate">Duplicate</MenuItem>
              </Select>
            </FormControl>
          ) : (
            undefined
          )}
          {userInRoles(user, [UserRoleTypeEnum.Administrator]) ? (
            <Button
              variant="contained"
              color="primary"
              className={classes.hierarchyButton}
              onClick={this.handleHierarchyAction}
            >
              Go
            </Button>
          ) : (
            undefined
          )}
        </form>
        {this.state.addHierarchyOpen && (
          <HierarchyModalForm
            open={this.state.addHierarchyOpen}
            handleClose={this.handleClose}
          />
        )}
        {this.state.showConfirmDelete && (
          <ConfirmModal
            title="Delete Hierarchy"
            message={`Are you sure you want to delete ${
              this.state.deleteHierarchyName
            }?`}
            handleOk={this.handleDelete}
            handleCancel={this.handleCancelDelete}
          />
        )}
      </div>
    );
  }
}

HierarchyManager.propTypes = {
  hierarchies: PropTypes.array.isRequired,
  hierarchyChange: PropTypes.func.isRequired,
  hierarchyDeleted: PropTypes.func,
  hierarchyAdded: PropTypes.func,
  hierarchyUpdated: PropTypes.func,
  hierarchyTypeId: PropTypes.number.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user.user,
    userIsLoading: state.user.userIsLoading
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        {
          LoadHierarchyModal: LoadHierarchyModal
        },
        SnackbarActions.actionCreators
      ),
      dispatch
    )
)(withStyles(styles)(HierarchyManager));
